<template>
  <el-card>
    <!-- 引入加载组件 -->
    <loading :loading_ok="loading_ok"></loading>
    <span class="title">官网管理</span>

    <div class="bottom_div">
      <el-button
        size="mini"
        type="primary"
        icon="el-icon-plus"
        @click="add_course_but"
      >
        添加
      </el-button>

      <el-table :data="tableData" class="table" border stripe>
        <el-table-column type="index" label="#"></el-table-column>
        <el-table-column prop="CreatedAt" label="日期"></el-table-column>
        <el-table-column label="图片/视频">
          <template slot-scope="scope">
            <div v-if="scope.row.Mark == '官网banner'">
              <video
                style="width:200px;"
                muted="muted"
                loop
                autoplay="autoplay"
                :src="scope.row.FileInfo.Url"
              ></video>
            </div>

            <div v-else>
              <img :src="scope.row.FileInfo.Url" style="width:100px;" />
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="Mark" label="所属板块"></el-table-column>
        <el-table-column prop="Text" label="主标题"></el-table-column>
        <el-table-column prop="SubText" label="副标题"></el-table-column>
        <el-table-column label="操作" min-width="90">
          <template slot-scope="scope">
            <el-button
              type="warning"
              icon="el-icon-edit"
              size="mini"
              @click="editCampus(scope.row)"
            >
              修改
            </el-button>
            <el-button
              type="danger"
              icon="el-icon-delete"
              size="mini"
              @click="delete_principal_button(scope.row)"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 添加课程课包弹框 -->
    <el-dialog
      :title="form.Id ? '修改' : '添加'"
      :visible.sync="add_course_subject"
      width="40%"
      :closeOnClickModal="false"
    >
      <el-form
        :inline="true"
        ref="formRef"
        :model="form"
        label-width="100px"
        label-position="right"
      >
        <el-form-item
          label="上传资源"
          prop="file"
          :rules="[
            {
              required: true,
              message: '资源不能为空',
              trigger: ['change', 'blur'],
            },
          ]"
          style="display: block;"
        >
          <el-upload
            ref="removeUpload"
            class="upload-demo"
            :action="uploadURL"
            :on-success="upload_success"
            :on-remove="upload_remove"
            multiple
            :limit="1"
            :on-exceed="handleExceed"
            style="width:100%;"
          >
            <el-button size="mini" type="primary">点击上传</el-button>
          </el-upload>
        </el-form-item>

        <el-form-item
          label="所属板块"
          prop="mark"
          :rules="[{ required: true, message: '所属板块不能为空' }]"
          style="display:block;"
        >
          <el-input placeholder="请输入所属板块" v-model="form.mark"></el-input>
        </el-form-item>

        <el-form-item label="文案主标题">
          <el-input placeholder="文案主标题" v-model="form.text"></el-input>
        </el-form-item>

        <el-form-item
          label="文案副标题"
          prop="subText"
          :rules="[{ required: true, message: '文案副标题不能为空' }]"
        >
          <el-input
            placeholder="banner文案副标题"
            v-model="form.subText"
          ></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="add_course_subject = false" size="mini">
          取消
        </el-button>
        <el-button type="primary" @click="add_principal_frame" size="mini">
          确定
        </el-button>
      </span>
    </el-dialog>
  </el-card>
</template>

<script>
import loading from "@/components/loading.vue";
import { mapGetters } from "vuex";
import {
  add_official_api,
  get_official_api,
  edit_official_api,
  delete_official_api,
} from "@/api/homePage.js";
import { upload_resources_image_api } from "@/api/resources.js";

export default {
  computed: {
    ...mapGetters(["current"]),
  },
  components: {
    loading,
  },

  data() {
    return {
      add_course_subject: false, //添加课程科目弹框打开关闭
      tableData: [], //表格数据
      form: {
        file: "",
        mark: "",
        subText: "",
        text: "",
      }, //表单数据
      subjectData: [],
      uploadURL: "",
      loading_ok: "",
    };
  },

  created() {
    this.getCourse_but();
    this.uploadURL = upload_resources_image_api();
  },

  methods: {
    //获取课程
    getCourse_but() {
      get_official_api().then((response) => {
        let value = response.data;
        value.forEach((v) => {
          v.FileInfo.Url = window.location.protocol + v.FileInfo.Url;
          v.CreatedAt = this.filters.vdateAdd(v.CreatedAt);
        });
        this.loading_ok = false;
        this.tableData = value;
      });
    },

    //添加按钮
    add_course_but() {
      this.form = {
        file: "",
        mark: "",
        subText: "",
        text: "",
      };
      if (this.$refs.formRef !== undefined) {
        this.$refs.formRef.resetFields();
      }
      this.add_course_subject = true;
    },

    // 表格修改按钮
    editCampus(item) {
      this.add_course_subject = true;
      this.form.Id = item.Id;
      this.form.file = item.File;
      this.form.mark = item.Mark;
      this.form.text = item.Text;
      this.form.subText = item.SubText;
    },

    // 表格删除按钮
    delete_principal_button(item) {
      this.$confirm("确定删除吗？", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        lockScroll: false,
      })
        .then(() => {
          delete_official_api(item.Id).then(() => {
            this.getCourse_but();
            this.$message.success("删除成功！");
          });
        })
        .catch(() => {
          this.$message.warning("您已取消操作！");
        });
    },

    // 添加/修改课程章节弹框确定按钮
    add_principal_frame() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          if (this.form.Id) {
            edit_official_api(this.form.Id, {
              file: this.form.file,
              mark: this.form.mark,
              text: this.form.text,
              subText: this.form.subText,
            }).then(() => {
              this.getCourse_but();
              this.$message.success("修改成功！");
              this.add_course_subject = false;
            });
          } else {
            add_official_api(this.form).then(() => {
              this.getCourse_but();
              this.$message.success("添加成功！");
              this.add_course_subject = false;
            });
          }
        }
      });
    },

    // 上传成功钩子
    upload_success(res) {
      this.form.file = res.Id;
    },

    // 移除上传文件钩子
    upload_remove() {
      this.form.file = "";
    },

    // 超出上传文件个数钩子
    handleExceed() {
      this.$message.error("目前仅支持上传单个文件");
    },
  },
};
</script>

<style lang="stylus" scoped>
.el-card {
  margin:16px;
  .title {
      color:#333;
      font-size:20px;
    }
    .bottom_div {
      margin-top:30px;
    }
    .table {
      margin-top:16px;
    }
}
</style>
